import { useEffect, useState } from "react";
import { setTitlePage } from "../../Functions";
import { useFormik } from "formik";
import * as Yup from 'yup'
import clsx from "clsx";
import { sendEmailContact } from "../../Api";

const mailSchema: any = Yup.object().shape({
    message: Yup.string().required("El mensaje es obligatorio")
})

const ContactUs = () => {

    const [loading, setLoading] = useState(false);
    const initialValues: any = {
        motivo: "1",
        message: ""
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: mailSchema,
        onSubmit: async (values: any, { setStatus, setSubmitting, resetForm }) => {
            setLoading(true);
            setStatus("")
            try {
                await sendEmailContact(values)
                resetForm();
                setStatus("success");
                setLoading(false);
                setSubmitting(false);
            } catch (e: any) {
                setStatus("error");
                setSubmitting(false);
                setLoading(false);
            }
        }
    })

    useEffect(() => {
        setTitlePage("Contáctenos")
    }, []);

    return (
        <div className="card p-5 text-gray-600">
            <div className="row mb-8">
                <div className="text-amsm fs-4 fw-bold">
                    Nos interesa su opinión, por favor seleccione el motivo de su mensaje y escriba su comentario.
                </div>
            </div>

            {formik.status && formik.status === 'success' ? (
                <div className='mb-5 alert alert-success alert-dismissible fade show' role="alert">
                    <div className='alert-text font-weight-bold'>Mensaje enviado correctamente</div>
                    <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
            ) : null}

            {formik.status && formik.status === 'error' ? (
                <div className='my-5 alert alert-danger alert-dismissible fade show' role="alert">
                    <div className='alert-text font-weight-bold'>Error al enviar el mensaje</div>
                    <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
            ) : null}

            <form className="" onSubmit={formik.handleSubmit} noValidate>
                <div className="row">
                    <div className="col-12">
                        <select className="form-select" aria-label="Default select example" {...formik.getFieldProps('motivo')}>
                            <option value="1">Felicitaciones</option>
                            <option value="2">Consulta</option>
                            <option value="3">Reclamo</option>
                        </select>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <textarea
                            className={clsx(
                                'form-control bg-transparent mt-3',
                                { 'is-invalid': formik.touched.message && formik.errors.message },
                                {
                                    'is-valid': formik.touched.message && !formik.errors.message,
                                }
                            )}
                            placeholder="Escriba su mensaje"
                            rows={5}
                            {...formik.getFieldProps('message')}
                        >

                        </textarea>
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-12 d-flex">
                        <span className="fw-bold  me-3">Teléfonos:</span>
                        <div>
                            <a href="tel:+56229133243">+56 2 2913 3243</a> <br />
                            <a href="tel:+56229133244">+56 2 2913 3244</a>
                        </div>
                    </div>

                </div>
                <div className="row pt-5">
                    <div className="col-12 text-end">
                        <button type="submit" className="btn btn-sm fw-bold btn-primary" disabled={formik.isSubmitting || !formik.isValid}>
                            <div className="d-flex align-items-center">
                                {!loading && <span className='indicator-label'>Enviar</span>}
                                {loading && (
                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                        Enviando...
                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                    </span>
                                )}
                            </div>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default ContactUs;
